import './contact-view-layout.component.ajs.ajscss';

import { Component, ContentChild, Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[cngContactViewLayoutActions]',
})
export class ContactViewLayoutActionsDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}

@Directive({
  selector: '[cngContactViewLayoutWorkspace]',
})
export class ContentViewLayoutWorkspaceDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}

@Component({
  selector: 'cng-contact-view-layout',
  templateUrl: './contact-view-layout.component.html',
})
export class ContactViewLayoutComponent {
  @ContentChild(ContactViewLayoutActionsDirective) actions: ContactViewLayoutActionsDirective;
  @ContentChild(ContentViewLayoutWorkspaceDirective) workspace: ContentViewLayoutWorkspaceDirective;
}
